import React, { useState, useEffect, useMemo } from "react";
import L from "leaflet";
import PropTypes from "prop-types";

// @material-ui/core components

import { Map, Marker, TileLayer } from "react-leaflet";

// import getCategories from "api/getCategories.js";
import searchNear from "api/search/search-near.js";
import SearchRestaurantCard from "componentCustom/SearchRestaurantCard.js";
import FooterContainer from "container/FooterContainer.js";
import FooterDownloadContainer from "container/FooterDownloadContainer.js";
import searchRestaurants from "api/search/search-restaurants.js";

// const useStyles = makeStyles(styles);

const centerMap = [41.89193, 12.51133];

export default function HomeMap(props) {
  // const classes = useStyles();
  const {
    city,
    updateCity
    // , attributes
  } = props;
  useEffect(() => {
    searchRestaurants(centerMap[0], centerMap[1])
      .then(res => {
        let restaurants = res || [];
        if (res) {
          restaurants = res.slice(0, 4);
        }
        return setList(restaurants);
      })
      .catch(err => {
        console.log(err);
        return null;
      });
  }, []);

  const [list, setList] = useState([]);
  useEffect(() => {
    if (city && !city.latitude) {
      const searchQuery = window.location.search;
      const [latitude, longitude] = searchQuery.match(
        /([0-9]{0,2})+\.+([0-9]{0,9})/g
      );
      const [, name] = searchQuery.split("&");
      updateCity({ latitude, longitude, name: name.replace(/-/g, " ") });
    }
    // eslint-disable-next-line
  }, []);

  const { card, marker } = useMemo(() => {
    const card2 = [];
    const marker2 = [];
    list.forEach(el => {
      /*
          Start creation marker on map
        */
      const markerPlain = L.icon({
        iconUrl: `https://cdn.foodiestrip.com/pins/categories/category${el.categories[0]._id}-70.png`,
        iconSize: [35, 35],
        iconAnchor: [15, 34]
      });
      let lat = el.location.coordinates[1];
      let lng = el.location.coordinates[0];
      marker2.push(
        <Marker icon={markerPlain} key={el._id} position={{ lat, lng }} />
      );
      /*
          End creation marker on map
        */

      /*
          Start creation card on list
        */
      card2.push(
        <div className="search-results-card-container" key={el._id.toString()}>
          <SearchRestaurantCard
            restaurant={el}
            // attributes={attributes}
          />
        </div>
      );

      /*
          End creation card on list
        */
    });
    return { card: card2, marker: marker2 };
  }, [list]);

  console.log("cityyyyyyyyyy", city);
  return (
    <div className="home-map-container">
      <link
        rel="stylesheet"
        href="https://unpkg.com/leaflet@1.1.0/dist/leaflet.css"
        // eslint-disable-next-line max-len
        integrity="sha512-wcw6ts8Anuw10Mzh9Ytw4pylW8+NAD4ch3lqm9lzAsTxg0GFeJgoAtxuCLREZSC5lUXdVyo/7yfsqFjQ4S+aKw=="
        crossOrigin=""
      />
      <script
        src="https://unpkg.com/leaflet@1.1.0/dist/leaflet.js"
        // eslint-disable-next-line max-len
        integrity="sha512-mNqn2Wg7tSToJhvHcqfzLMU6J4mkOImSPTxVZAdo+lcPlk+GhZmYgACEe0x35K7YzW1zJ7XyJV/TT1MrdXvMcA=="
        crossOrigin=""
      />
      <Map
        id={"home-map"}
        center={
          city && city.latitude && city.longitude
            ? [city.latitude, city.longitude]
            : centerMap
        }
        maxZoom={18}
        scrollWheelZoom={false}
        zoom={12}
        length={4}
        style={{
          width: "100%",
          height: "calc(100vh - 390px)",
          // minHeight: "calc( - 482px)",
          overflow: "hidden"
        }}
      >
        <TileLayer
          attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, Tiles courtesy of <a href="http://hot.openstreetmap.org/" target="_blank">Humanitarian OpenStreetMap Team</a>'
          url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
        />
        {marker}
      </Map>
      <FooterContainer />
      <FooterDownloadContainer />
    </div>
  );
}

HomeMap.propTypes = {
  city: PropTypes.object.isRequired,
  updateCity: PropTypes.func.isRequired
  // attributes: PropTypes.object.isRequired
};
